import { SecurityQuestionsInformation } from "@/types";
import { CoreFieldProps, fieldTypes, Option, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";
import { SecurityQuestion } from "@/types/enums";

export interface SecurityQuestionsInformationComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
  shouldHide?: boolean;
}

export interface SecurityQuestionsInformationComplexFieldProps
  extends fieldTypes.BaseFieldProps<SecurityQuestionsInformation> {
  showHeader?: boolean;
  complexFieldValue?: SecurityQuestionsInformationComplexValue;
}

export const SecurityQuestionsInformationComplexField: FC<
  SecurityQuestionsInformationComplexFieldProps
> = (props) => {
  const readOnly = props.complexFieldValue?.readOnly || props.readOnly;
  const shouldHide = props.complexFieldValue?.shouldHide;

  const optionsFilter = (option: Option<SecurityQuestion>) => {
    return (
      option.value !== props.value?.securityQuestion1 &&
      option.value !== props.value?.securityQuestion2 &&
      option.value !== props.value?.securityQuestion3
    );
  };

  // Hide security questions when shouldHide is true
  if (shouldHide) {
    return null;
  }

  return (
    <section className="complex-field-container security-questions-information security-questions-six-columns">
      <SectionHeader label={props.complexFieldValue?.headerLabel || props.label} hidden={!props.complexFieldValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.SECURITY_QUESTIONS_INFORMATION.SECURITY_QUESTION_1}
          complexFieldProps={
            {
              optionsFilter,
              disabled: readOnly,
            } as CoreFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.SECURITY_QUESTIONS_INFORMATION.SECURITY_ANSWER_1}
          complexFieldProps={
            {
              disabled: readOnly,
            } as CoreFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.SECURITY_QUESTIONS_INFORMATION.SECURITY_QUESTION_2}
          complexFieldProps={
            {
              optionsFilter,
              disabled: readOnly,
            } as CoreFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.SECURITY_QUESTIONS_INFORMATION.SECURITY_ANSWER_2}
          complexFieldProps={
            {
              disabled: readOnly,
            } as CoreFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.SECURITY_QUESTIONS_INFORMATION.SECURITY_QUESTION_3}
          complexFieldProps={
            {
              optionsFilter,
              disabled: readOnly,
            } as CoreFieldProps
          }
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.SECURITY_QUESTIONS_INFORMATION.SECURITY_ANSWER_3}
          complexFieldProps={
            {
              disabled: readOnly,
            } as CoreFieldProps
          }
        />
      </div>
    </section>
  );
};
